// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"b12aa68c","910":"4a01f7c2"}[chunkId] + ".chunk.js";
};